module.exports = "<rnpl-attr-list [entityType]=\"type\" [entity]=\"entity\"></rnpl-attr-list>\n"